import { Link } from 'react-router-dom';
import { quickAccessItems } from '@/mocks/codesajan';

const colorMap: Record<string, { bg: string; icon: string; hover: string; border: string; ring: string }> = {
  primary: {
    bg: 'bg-primary-50',
    icon: 'bg-primary-500 text-white',
    hover: 'hover:bg-primary-500 hover:text-white hover:border-primary-500',
    border: 'border-primary-100',
    ring: 'group-hover:ring-primary-200',
  },
  accent: {
    bg: 'bg-accent-50',
    icon: 'bg-accent-500 text-white',
    hover: 'hover:bg-accent-500 hover:text-white hover:border-accent-500',
    border: 'border-accent-100',
    ring: 'group-hover:ring-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-50',
    icon: 'bg-secondary-500 text-white',
    hover: 'hover:bg-secondary-500 hover:text-white hover:border-secondary-500',
    border: 'border-secondary-100',
    ring: 'group-hover:ring-secondary-200',
  },
};

export default function QuickAccess() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
              Accesos Directos
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
              Todo lo que necesitás
            </h2>
            <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
              Gestiona tu servicio de agua de forma rápida y sencilla desde cualquier dispositivo.
            </p>
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {quickAccessItems.map((item, i) => {
              const colors = colorMap[item.color] || colorMap.primary;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`group relative flex flex-col p-5 md:p-6 rounded-xl border ${colors.border} bg-background-50 transition-all duration-400 hover-lift hover:-translate-y-1.5 ${colors.hover}`}
                  style={{ animationDelay: `${0.1 * i}s` }}
                >
                  {/* Icon */}
                  <div className={`w-11 h-11 rounded-xl ${colors.icon} flex items-center justify-center mb-4 transition-all duration-300`}>
                    <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>

                  {/* Title */}
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-white transition-colors mb-2">
                    {item.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-foreground-600 group-hover:text-white/80 transition-colors leading-relaxed flex-grow">
                    {item.description}
                  </p>

                  {/* Arrow */}
                  <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-foreground-500 group-hover:text-white/90 transition-colors">
                    <span>Acceder</span>
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1"></i>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}